/**
 * Safe Overlay Utility - Prevents XSS by using DOM API instead of innerHTML
 */

export const showLoadingOverlay = (message = 'Wird geladen...') => {
  const overlay = document.createElement('div');
  overlay.id = 'safe-loading-overlay';
  overlay.style.cssText = `
    position: fixed;
    inset: 0;
    background: rgba(0,0,0,0.8);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 999999;
  `;

  const content = document.createElement('div');
  content.style.cssText = `
    text-align: center;
    color: white;
  `;

  const spinner = document.createElement('div');
  spinner.style.cssText = `
    width: 48px;
    height: 48px;
    border: 3px solid rgba(255,255,255,0.3);
    border-top-color: white;
    border-radius: 50%;
    animation: spin 1s linear infinite;
    margin: 0 auto 16px;
  `;

  const text = document.createElement('div');
  text.style.cssText = `font-size: 16px; font-weight: 500;`;
  text.textContent = message;

  // Add keyframes
  if (!document.getElementById('safe-spinner-styles')) {
    const style = document.createElement('style');
    style.id = 'safe-spinner-styles';
    style.textContent = '@keyframes spin { to { transform: rotate(360deg); } }';
    document.head.appendChild(style);
  }

  content.appendChild(spinner);
  content.appendChild(text);
  overlay.appendChild(content);
  document.body.appendChild(overlay);

  return overlay;
};

export const hideLoadingOverlay = () => {
  const overlay = document.getElementById('safe-loading-overlay');
  if (overlay) overlay.remove();
};

export const showDownloadOverlay = (message = 'Bild wird vorbereitet...') => {
  return showLoadingOverlay(message);
};

export default { showLoadingOverlay, hideLoadingOverlay, showDownloadOverlay };
